import { TableCell, Typography } from '@mui/material';
import { pickupStreamServiceURL } from '@shared';
import { RowType } from '../../Review.utils';
import * as S from './ExamInfo.styled';
import { hrefLinkStyles } from './ExamInfo.styled';

export function ExamInfoTableCells(props: RowType) {
  const { label, value, path } = props;

  const renderValueCell = () => {
    if (label === 'Partner' || label === 'Course' || label === 'Exam') {
      return (
        <TableCell size='small'>
          <S.StyledLink to={path || ''}>
            <Typography>{value}</Typography>
          </S.StyledLink>
        </TableCell>
      );
    } else if (label === 'Stream Detail') {
      return (
        <TableCell size='small'>
          <Typography
            sx={(theme) => hrefLinkStyles(theme)}
            component='a'
            href={`${pickupStreamServiceURL()}/streams/${value}`}
            target='_blank'
            rel='noopener noreferrer'
          >
            {`${pickupStreamServiceURL()}/streams/${value}`}
          </Typography>
        </TableCell>
      );
    } else {
      return (
        <TableCell size='small'>
          <Typography variant='tableCell'>{value}</Typography>
        </TableCell>
      );
    }
  };

  return (
    <>
      <TableCell size='small'>
        <Typography variant='tableCell'>{label}</Typography>
      </TableCell>
      {renderValueCell()}
    </>
  );
}
